module.exports = __webpack_public_path__ + "static/img/contant_1.ba7e7fd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1st/Articles/Article_11/contant_1.jpg
// module id = jRZB
// module chunks = 0